import { Modal, ModalBody } from "reactstrap";
import './Default.css';
import { TfiClose } from "react-icons/tfi";

function DefaultModal({isOpen, toggle, children, title, size="md"}) {
  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size={size}
      centered
      zIndex={9050}
    >
      <ModalBody>
        <div className="moda-close-btn" onClick={toggle}>
          <TfiClose />
        </div>
        <div className="text-center mb-3">
          <h4>{title}</h4>
        </div>

        {children}
      </ModalBody>
    </Modal>
  );
}

export default DefaultModal;